import { DEFAULT_SESSION_IDLE_MINUTES } from '../core/models/PlatformConfig';

export const SESSION_IDLE_MINUTE_OPTIONS = [5, 10, 15, 30, 45, 60, 90, 120] as const;

/** Sign out after this much idle time when platform config is unavailable. */
export const SESSION_IDLE_TIMEOUT_MS = DEFAULT_SESSION_IDLE_MINUTES * 60 * 1000;

/** Minimum gap between idle-timer resets from high-frequency events. */
export const SESSION_IDLE_ACTIVITY_THROTTLE_MS = 1000;

/** Warn this long before logout (clamped below the idle timeout). */
export const SESSION_IDLE_WARN_BEFORE_MS = 2 * 60 * 1000;

export function resolveIdleWarnBeforeMs(
  timeoutMs: number,
  warnBeforeMs = SESSION_IDLE_WARN_BEFORE_MS,
): number {
  const timeout = Math.max(1_000, Number(timeoutMs) || SESSION_IDLE_TIMEOUT_MS);
  const warn = Math.max(1_000, Number(warnBeforeMs) || SESSION_IDLE_WARN_BEFORE_MS);
  return Math.min(warn, Math.max(1_000, timeout - 1_000));
}
